import React from "react";
import { Radio, Col, Row, Space } from "antd";
import checkmark from "@images/checkmark.svg?url";
import noTimeLockIcon from "./icons/ico-no-timelock.svg?url";
import timeLock1yIcon from "./icons/ico-timelock-1.svg?url";
import timeLock2yIcon from "./icons/ico-timelock-2.svg?url";
import timeLock3yIcon from "./icons/ico-timelock-3.svg?url";
import timeLock4yIcon from "./icons/ico-timelock-4.svg?url";
import timeLock5yIcon from "./icons/ico-timelock-5.svg?url";
import ArrowIcon from "./icons/ico-arrow.svg";
import { formatNumberToUSD } from "@features/utils/functions";

import * as styles from "./TimeLockOptionStyle.module.scss";
import { useMediaQuery } from "react-responsive";
import classNames from "classnames";

type Props = {
  title: string;
  active: boolean;
  rewardFee: number;
  custodyFee: string;
  timelockDuration: number | null;
  taxSubscription: string;
  unstakeInfo?: string;
  minValue: number;
  isUk?: boolean;
  onClick: (selectedData: Record<string, number | null>) => void;
};

const timeLockIconsMap: { [key: string]: string } = {
  1: timeLock1yIcon,
  2: timeLock2yIcon,
  3: timeLock3yIcon,
  4: timeLock4yIcon,
  5: timeLock5yIcon,
};

const TimeLockOption = ({
  title,
  active,
  rewardFee,
  custodyFee,
  unstakeInfo,
  timelockDuration,
  minValue,
  isUk,
  onClick,
}: Props) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div
      className={classNames(
        styles.timeLockOption,
        active && styles.timeLockOptionActive
      )}
      onClick={() =>
        onClick({
          timelockFee: rewardFee,
          timelockDuration,
        })
      }
    >
      <div className={styles.timeLockOptionHeader}>
        <div className={styles.timeLockOptionHeaderTitle}>
          <img
            src={
              timelockDuration
                ? timeLockIconsMap[timelockDuration]
                : noTimeLockIcon
            }
          />
          <span className={styles.timeLockOptionTitle}>{title}</span>
        </div>

        <Space>
          {unstakeInfo && (
            <span className={styles.timeLockOptionUnstakeInfo}>
              {unstakeInfo}
            </span>
          )}
          <Radio checked={active} />
        </Space>
      </div>
      <div
        className={
          isMobile
            ? "py-6 px-8 bg-grey-light rounded-[12px]"
            : styles.timeLockOptionInfoSection
        }
      >
        <Row>
          <Col xs={24} lg={13}>
            <Row
              className={classNames(
                isMobile
                  ? "uppercase font-semibold text-xs mb-4"
                  : styles.timeLockOptionInfoTitle
              )}
            >
              <Col>Fees</Col>
            </Row>
            <Row>
              <Col xs={24} sm={12} lg={11}>
                <Space direction="vertical" size={0}>
                  <span className={styles.timeLockOptionInfoSectionHeader}>
                    STAKING REWARD FEE
                  </span>{" "}
                  <span>{rewardFee.toString()}%</span>
                  <span className={styles.timeLockOptionInfoSectionSecondary}>
                    Paid in ETH in kind
                  </span>
                </Space>
              </Col>
              <Col xs={24} sm={12} lg={13}>
                <Space direction="vertical" size={0}>
                  <span className={styles.timeLockOptionInfoSectionHeader}>
                    PUBLIC EQUITY CUSTODY FEE
                  </span>{" "}
                  <span>{custodyFee}</span>
                  <span className={styles.timeLockOptionInfoSectionSecondary}>
                    Paid in Shares in kind
                  </span>
                </Space>
              </Col>
            </Row>
          </Col>

          <Col xs={{ span: 24, offset: 0 }} lg={{ span: 10, offset: 1 }}>
            <Row
              className={classNames(
                isMobile
                  ? "uppercase font-semibold text-xs border-t border-[#E4E4E4] pt-[30px] mb-4 mt-[30px]"
                  : styles.timeLockOptionInfoTitle
              )}
            >
              <Col xs={24}>{isUk ? "Features" : "Bonuses"}</Col>
            </Row>
            <Row>
              <Col xs={24}>
                {timelockDuration ? (
                  <>
                    <div className="mb-2">
                      <a
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        href="https://bnktothefuture.com/blog/connecting-your-bf-account-to-recap/"
                        target="_blank"
                        className={classNames(
                          styles.timeLockOptionBonus,
                          "underline mb-2",
                          {
                            "text-sm": isMobile,
                          }
                        )}
                      >
                        {isMobile
                          ? "50% subscription discount"
                          : "50% discounted tax software subscription"}
                        <ArrowIcon />
                      </a>
                      <a
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        href={
                          isUk
                            ? "https://www.bitcoinwealthbuilder.io/bwb "
                            : "https://www.simondixon.com/bwb"
                        }
                        target="_blank"
                        className={classNames(
                          styles.timeLockOptionBonus,
                          "underline",
                          {
                            "text-sm": isMobile,
                          }
                        )}
                      >
                        {isMobile
                          ? "Bitcoin Wealth Builder"
                          : "Simon Dixon’s Bitcoin Wealth Builder Program"}

                        <ArrowIcon />
                      </a>
                    </div>

                    <span className={styles.timeLockOptionInfoSectionSecondary}>
                      Applied if request is more than{" "}
                      {formatNumberToUSD(minValue)}
                    </span>
                  </>
                ) : (
                  <p className={styles.timeLockOptionBonus}>None</p>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TimeLockOption;
